var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.row.offer_buy.thread_id != null)?_c('ui-button',{attrs:{"type":"secondary"},on:{"click":function($event){_vm.$inertia.visit(
				_vm.$route('threads', { active_id: _vm.row.offer_buy.thread_id })
			)}}},[_vm._v("\n\t\t"+_vm._s(_vm.__("To negotiation"))+"\n\t")]):_c('ui-button',{staticClass:"ml-auto text-sm flex-shrink-0",attrs:{"type":"primary"},on:{"click":function($event){_vm.$bus.$emit(
				'toggle-iframe-modal',
				_vm.$route('bid.create', {
					targetType: 'BUY',
					targetId: _vm.row.offer_buy.id,
				}) + '?iframe_modal=true'
			)}}},[_vm._v(_vm._s(_vm.__("Offer")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }